// No Subresource Integrity hash is added for this script: Convert's loader
// dynamically serves whichever A/B-test experiments are currently
// configured for this account, so its bytes are not fixed at this URL and
// a pinned hash would break the next time an experiment changes — SRI only
// applies to a genuinely immutable resource. Self-hosting isn't practical
// for the same reason. The compensating control is the CSP connect-src/
// script-src allowlist in nuxt.config.ts, computed from this same
// NUXT_PUBLIC_CONVERT_LINK value so it never needs a wildcard vendor
// domain — see that file and the accompanying security report.
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (!config.public.convertLink) {
    return;
  }

  // Coerced here (not only in nuxt.config.ts) because Nuxt re-applies its
  // own NUXT_PUBLIC_CONVERT_LINK env-var override to runtimeConfig.public
  // at server start, which would otherwise silently undo a build-time-only
  // fix — this guarantees the script never actually loads over plain http,
  // regardless of how that env var is set.
  const convertLink = config.public.convertLink.startsWith("http://")
    ? "https://" + config.public.convertLink.slice("http://".length)
    : config.public.convertLink;

  const script = document.createElement("script");
  script.src = convertLink;
  script.async = true;

  document.head.appendChild(script);
});
